import actionCreatorFactory from './action-creator-factory';

export const FormActionTypes = {
  SUBMIT_FORM: 'SUBMIT_FORM',
  SUBMIT_FORM_COMPLETE: 'SUBMIT_FORM_COMPLETE',
  SUBMIT_FORM_ERROR: 'SUBMIT_FORM_ERROR',
};

export default actionCreatorFactory(FormActionTypes);



// WEBPACK FOOTER //
// ./src/actions/form-actions.js